import React from 'react';
import Request from '../utils/Request';
import { EmployeeType } from '../types/EmployeeType';
import LoadingComponent from '../components/LoadingComponent';
import Skeleton from 'react-loading-skeleton';
import { Col, Figure, Row, Stack } from 'react-bootstrap';

type Props = {
  loading?: React.RefObject<LoadingComponent | null>;
};

type State = {
  employees: { [key: number]: EmployeeType[] };
  text: undefined;
  photo?: string;
};

export default class AboutPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { employees: [], text: undefined, photo: undefined };
  }

  componentDidMount() {
    document.title = (process.env.REACT_APP_NAME ?? 'Kaz Studio') + ' - About us';

    Request.sendRequest('about-list/about-page').then((result) => {
      const text = result.data.data.content;
      this.setState({ text: text });
      this.props.loading?.current?.closeAnimation();
    });

    Request.sendRequest('about-list/about-page/photo').then((result) => {
      this.setState({ photo: result.data.data.url });
    });

    Request.sendRequest('employees').then((response) => {
      const { success, data } = response.data;
      if (!success) return;
      const employees: EmployeeType[] = data;
      const result = employees.reduce((rv: { [key: number]: EmployeeType[] }, x) => {
        (rv[x.position.vertical] = rv[x.position.vertical] || []).push(x);
        return rv;
      }, {});
      this.setState({ employees: result });
    });
  }

  render(): JSX.Element {
    return (
      <div className="page about-page">
        <Stack className="content" direction="horizontal" style={{ alignItems: 'flex-start' }}>
          <div style={{ width: '33%' }}>
            <h1 className="about-text-title">About</h1>
          </div>
          <div className="fade-in-image" style={{ width: '66%' }}>
            {this.state.text ? (
              <div className="text" dangerouslySetInnerHTML={{ __html: this.state.text }}></div>
            ) : (
              <>
                <Skeleton
                  className="mb-2"
                  baseColor="#707070"
                  highlightColor="#535353"
                  count={1}
                  width={250}
                  height={20}
                />
                <Skeleton baseColor="#707070" highlightColor="#535353" count={2} height={10} />
                <Skeleton
                  baseColor="#707070"
                  highlightColor="#535353"
                  count={1}
                  width="60%"
                  height={10}
                />
                <Skeleton
                  baseColor="#707070"
                  highlightColor="#535353"
                  count={1}
                  width="80%"
                  height={10}
                />
              </>
            )}
          </div>
        </Stack>

        <div className="mt-3 employees">
          <h2
            style={{ margin: '0 auto', width: '100%', textAlign: 'center', marginBottom: '6rem' }}
          >
            Our Team
          </h2>
          {Object.keys(this.state.employees).map((key, index) => {
            const employees = this.state.employees[Number.parseInt(key)];
            return (
              <div key={`row-${index}`} className="row">
                {employees.map((employee) => (
                  <div className="employee" key={`employee-${employee.id}`}>
                    <Figure className="fade-in-image row">
                      <Col className="img-wrapper">
                        <Figure.Image className="photo" src={employee?.photo} />
                      </Col>
                      <Col>
                        <h2 className="name">{employee?.name}</h2>
                        <Figure.Caption className="caption">{employee?.role}</Figure.Caption>
                      </Col>
                    </Figure>
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
